import React, { useContext, useEffect, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import { useFetch } from '../../hooks'
import { FormSelectFilter } from '../../components/molecules'
import { WButton } from '../../components/atoms'
import { Card, CardBody, CardHeader, Row } from 'reactstrap'
import { volumeReportFilterDataContext } from '../../HOC/volumeReportFiltersContext'

function VolumeFilterForm() {
	const [name, setName] = useState('')
	const [locale, setLocale] = useState('')
	const [filteredNames, setFilteredNames] = useState([])

	const countries = useFetch({ url: 'volume-report-scheduled/countries/' })
	const namesList = useFetch({ url: 'volume-report-scheduled/names/' })

	const [, , getFilteredData, , actualPage, setActualPage] = useContext(volumeReportFilterDataContext)

	useEffect(() => {
		if (namesList && namesList.data) {
			setFilteredNames(namesList.data)
		}
	}, [namesList])

	useEffect(() => {
		if (namesList && namesList.data) {
			const query = name.toLowerCase()
			setFilteredNames(
				namesList.data.filter(n => n.toLowerCase().includes(query)).slice(0, 10)
			)
		}
	}, [name, namesList])

	const handleClearFilters = () => {
		setActualPage(1)
		setName('')
		setLocale('')
		getFilteredData({ page_size: 10, page: 1 })
	}

	const handleApplyFilters = () => {
		setActualPage(1)
		let params = {
			...(name.length > 0 && { name: name }),
			...(locale.length > 0 && { locale: locale }),
			page_size: 10,
			page: 1,
		}
		getFilteredData(params)
	}

	return (
		<>
			{countries && (
				<div className="pb-8 pt-5 pt-md-8">
					<Row>
						<div className="col">
							<Card className="shadow">
								<CardHeader className="border-0">
									<h1 className="mb-0">Filters</h1>
								</CardHeader>
								<CardBody className="pt-0">
									<Form>
										<Row className="justify-content-center" style={{ marginLeft: "80px", marginRight: "80px" }}>
											<Col>
												<Form.Group>
													<Form.Label>Name</Form.Label>
													<Form.Control
														placeholder="Name"
														value={name}
														onChange={(e) => setName(e.target.value)}
													/>
													{name && filteredNames.length > 0 && (
														<ul style={{ listStyle: 'none', padding: 0, border: '1px solid #ccc', borderRadius: '4px', marginTop: '5px', position: 'absolute', zIndex: 1000, background: 'white', width: '90%' }}>
															{filteredNames.map((n, index) => (
																<li
																	key={index}
																	style={{ padding: '5px 10px', cursor: 'pointer' }}
																	onClick={() => setName(n)}
																>
																	{n}
																</li>
															))}
														</ul>
													)}
												</Form.Group>
											</Col>
											<Col>
												<FormSelectFilter
													label={'Country'}
													value={locale}
													onChange={setLocale}
													data={countries.data}
												/>
											</Col>
										</Row>
									</Form>
									<Row style={{ display: "flex", justifyContent: "flex-end", marginRight: "92px" }}>
										<WButton label="Clear Filters" variant="light" onClick={handleClearFilters} />
										<WButton label="Apply" variant="primary" onClick={handleApplyFilters} />
									</Row>
								</CardBody>
							</Card>
						</div>
					</Row>
				</div>
			)}
		</>
	)
}
export default VolumeFilterForm
